module.exports = __webpack_public_path__ + "img/voice-thumb11.b66c1f8.jpg";